var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurderFastFoodDrink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 64,
    viewBox: "0 0 64 64",
    width: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 23-3-20",
    stroke: "#979797",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27 20h27l-3 36h-21z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 37.5,
    fill: "#22ba8e",
    r: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#5ea7ff",
    height: 4,
    rx: 2,
    width: 31,
    x: 25,
    y: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.38099862 56c-2.71549646-2.8673292-4.38099862-6.7391652-4.38099862-11 0-8.836556 7.163444-16 16-16s16 7.163444 16 16c0 4.2608348-1.6655022 8.1326708-4.3809986 11z",
    fill: "#ffdd95"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#bd7575",
    height: 6,
    rx: 3,
    width: 38,
    y: 44
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ed9111"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 34,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 37,
    r: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurderFastFoodDrink);
export default __webpack_public_path__ + "static/media/burder-fast-food-drink.d29628beae906060b6530a2d6246d7fb.svg";
export { ForwardRef as ReactComponent };